import { PromiseCompletionSource } from "by/gamefactory/shared/async/PromiseCompletionSource";
import { BaseScalableView } from "../../../common/BaseScalableView";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { YouNoMoreOwnerResourcePackage } from "../resources/YouNoMoreOwnerResourcePackage";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { IDestroyOptions, Sprite, Text, TextStyle } from "pixi.js";
import { ButtonWithScaleAnimation } from "../../../common/components/ButtonWithScaleAnimation";
import { GameFont } from "../../../common/GameFont";
import { YouNoMoreOwnerContainer } from "../components/youNoMoreOwner/YouNoMoreOwnerContainer";
import { YouNoMoreOwnerSceneResult } from "../scenes/YouNoMoreOwnerSceneResult";

export class YouNoMoreOwnerPopupView extends BaseScalableView<YouNoMoreOwnerSceneResult> {
    private static readonly HEADER_FIRST_TEXT = 'IMPORTANT';
    private static readonly HEADER_SECOND_TEXT = 'NOTICE!';

    private readonly commonResources: CommonResourcesPackage;
    private readonly youNoMoreOwnerResources: YouNoMoreOwnerResourcePackage;

    private viewBackground: Sprite;
    private topLight: Sprite;
    private leftLight: Sprite;
    private rightLight: Sprite;

    private speakers: Sprite;
    private headerFirstText: Text;
    private headerSecondText: Text;
    private viewContainer: YouNoMoreOwnerContainer;
    private closeButton: ButtonWithScaleAnimation;

    public constructor(
        operationControls: PromiseCompletionSource<YouNoMoreOwnerSceneResult>,
        canvasScaler: ICanvasScaler,
        commonResources: CommonResourcesPackage,
        youNoMoreOwnerResources: YouNoMoreOwnerResourcePackage,
    ) {
        super(operationControls, canvasScaler);
        this.commonResources = commonResources;
        this.youNoMoreOwnerResources = youNoMoreOwnerResources;
        this.build();
        this.layout(this.canvasScaler.referenceWidth, this.canvasScaler.referenceHeight);
        this.closeButton.onUp.add(this.onCloseButtonClickHandle, this);
        this.viewContainer.onTakeMeToMPButtonClick.add(this.onTakeMeToMPButtonClickHandle, this);
    }

    public start(): void { }

    private build(): void {
        this.viewBackground = new Sprite(this.commonResources.assets_common_blured_backgrounds_blurry_lobby_jpg);
        this.viewBackground.eventMode = 'static';
        this.topLight = new Sprite(this.youNoMoreOwnerResources.assets_views_you_no_more_owner_top_light_png);
        this.leftLight = new Sprite(this.commonResources.assets_common_ui_lights_light_left_png);
        this.rightLight = new Sprite(this.commonResources.assets_common_ui_lights_light_left_png);
        this.rightLight.scale.x = -1;
        this.speakers = new Sprite(this.youNoMoreOwnerResources.assets_views_you_no_more_owner_speaker_png);
        this.headerFirstText = new Text(YouNoMoreOwnerPopupView.HEADER_FIRST_TEXT, new HeaderTextStyle());
        this.headerFirstText.angle = -5;
        this.headerFirstText.skew.x = -0.087;
        this.headerSecondText = new Text(YouNoMoreOwnerPopupView.HEADER_SECOND_TEXT, new HeaderTextStyle());
        this.headerSecondText.style.fontSize = 232;
        this.headerSecondText.angle = -5;
        this.headerSecondText.skew.x = -0.087;
        this.viewContainer = new YouNoMoreOwnerContainer(this.commonResources, this.youNoMoreOwnerResources);
        this.closeButton = new ButtonWithScaleAnimation(this.commonResources.assets_common_x_png);

        this.addChild(
            this.viewBackground,
            this.topLight,
            this.leftLight,
            this.rightLight,
            this.headerFirstText,
            this.headerSecondText,
            this.viewContainer,
            this.speakers,
            this.closeButton
        );
    }

    private async onCloseButtonClickHandle(): Promise<void> {
        this.operationControls.complete(YouNoMoreOwnerSceneResult.NONE);
    }

    private async onTakeMeToMPButtonClickHandle(): Promise<void> {
        this.operationControls.complete(YouNoMoreOwnerSceneResult.SHOW_MARKETPLACE);
    }

    private layout(width: number, _height: number): void {
        this.leftLight.position.set(0, 921);
        this.rightLight.position.set(width, 921);
        this.headerFirstText.position.set(152, 280);
        this.headerSecondText.position.set(148, 410);
        this.viewContainer.position.set(width * 0.5 - this.viewContainer.width * 0.5, 583);
        this.closeButton.position.set(374, 1624);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.closeButton.onUp.remove(this.onCloseButtonClickHandle, this);
        this.viewContainer.onTakeMeToMPButtonClick.remove(this.onTakeMeToMPButtonClickHandle, this);
        super.destroy(options);
    }
}

class HeaderTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 155,
            fill: [
                "FB6642",
                "F8346A"
            ],
            fillGradientType: 1,
            dropShadow: true,
            dropShadowAlpha: 0.4,
            dropShadowAngle: 0.7,
            dropShadowBlur: 10,
            dropShadowColor: "0D0606",
            dropShadowDistance: 6
        });
    }
}
